import queryString from 'querystring';

/**
 * @param {Object} data
 * @param {string} data.externalId
 * @param {string} data.notification
 * @param {string} data.documentType
 * @return {String}
 */
export default function purchaseDocumentUrl(data) {
  if(data.notification === 'com.sunbit.notification.loan'){
    return loanPaymentDisclosureUrl(data.externalId);
  } else {
    return `/purchase-document/${encodeURIComponent(data.externalId)}?${queryString.stringify({notification: data.notification, documentType: data.documentType})}`;
  }

}

function loanPaymentDisclosureUrl(externalId) {
  return `/document/loan-payment-disclosure?${queryString.stringify({externalId: externalId})}`;
}



// WEBPACK FOOTER //
// ./src/utils/url/purchaseDocumentUrl.js